import { URLS } from "@constants/urls";
import api from "@helpers/api";

import { PaginationRequestType } from "@type/HRM/pagination";
import { PositionsResponseType } from "@type/HRM/position";
import axios from "axios";
import fileDownload from "js-file-download";

const apiEndPointForDownload = `${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_REPORT_GENERATION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.REPORTS}`;

export const getExtraPositionInformations = (() => {
  return async (
    data: PaginationRequestType,
  ): Promise<PositionsResponseType> => {
    const {
      page,
      size,
      search,
      positionOrder,
      isAvailable,
      addressId,
      positionId,
      unitId,
    } = data;

    const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/unit/position/employee/extra-responsibility`;

    return api
      .get(apiEndPoint, {
        params: {
          page,
          size,
          search,
          positionOrder,
          isAvailable,
          addressId,
          positionId,
          unitId,
        },
      })
      .then((response) => {
        const { data, page, size, total } = response.data;

        return {
          data,
          pagination: {
            page,
            size,
            total,
          },
        };
      });
  };
})();

export const downloadExtraPositionReport = async (
  token: string,
  fileName: string,
  queries: any,
) => {
  try {
    const res = await axios.get(
      `${apiEndPointForDownload}/pdf/employee-extra-position-info`,
      {
        params: {
          ...queries,
        },
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    fileDownload(res.data, `${fileName}.pdf`);
  } catch (error) {
    alert("Error downloading file");
  }
};
